import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { useTranslation } from 'react-i18next';
import { InternalScheduleActionsProps } from './types';

export const InternalScheduleActions = ({
  onCancel,
  onSendSchedule,
  onRescheduleAsDraft,
  onSaveAsDraft,
  locked,
  scheduleId,
  foremanId,
  readOnly = false,
  isDraft = false,
  hideCancel = false,
}: InternalScheduleActionsProps) => {
  const { t } = useTranslation('app');

  const isNewSchedule = scheduleId === 'new' || !scheduleId;
  const send = !readOnly && onSendSchedule && (isDraft || isNewSchedule) && foremanId;

  return (
    <div className="flex flex-col gap-2">
      {isDraft && (
        <span className="text-right text-sm text-neutral-700">
          {t('schedules.saveAsDraftTooltip')}
        </span>
      )}
      <div className="flex items-center justify-end gap-2">
        {!hideCancel && (
          <Button variant="ghost" disabled={false} onClick={onCancel}>
            {t('actions.cancel')}
          </Button>
        )}
        {!readOnly && !isDraft && (
          <Button
            variant="tertiary"
            type={!isNewSchedule && onRescheduleAsDraft ? 'button' : 'submit'}
            disabled={locked}
            onClick={!isNewSchedule && onRescheduleAsDraft ? onRescheduleAsDraft : onSaveAsDraft}>
            {isNewSchedule ? t('actions.saveAsDraft') : t('actions.saveDraft')}
          </Button>
        )}
        {!readOnly && !isNewSchedule && (
          <Button
            variant={send ? 'tertiary' : 'default'}
            disabled={locked}
            type="submit"
            onClick={isDraft ? onSaveAsDraft : undefined}>
            {isDraft ? t('actions.saveDraft') : t('actions.reschedule')}
          </Button>
        )}
        {send && (
          <Button disabled={locked} onClick={onSendSchedule}>
            <SvgConsumer id="message" className="text-lg" />
            {t('actions.sendSchedule')}
          </Button>
        )}
      </div>
    </div>
  );
};
